/**
 * ExchangeTransaction
 */
class ExchangeTransaction {
    constructor(transactionId) {
        this._transactionId = transactionId;
        this._locked = false;
        this._transactionStatusElement = $('.transaction_status');
        // refresh
        var that = this;
        setInterval(function () {
            that._refreshTransactionStatus();
        }, 30000);
    }

    _lock() {
        this._locked = true;
    }

    _unlock() {
        this._locked = false;
    }

    _refreshTransactionStatus() {
        var that = this;
        if (that._locked) {
            return;
        }
        
        that._lock();
        $.ajax({
            url: '/exchange/transaction/status/' + that._transactionId,
            dataType: "json",
            data: {
                json: true,
            },
            success: function (data) {
                if (data !== null && data.transaction_status !== null) {
                    var statusHtml = data.transaction_status.status;
                    if (data.transaction_status.status != "finished" && data.transaction_status.status != "failed" && data.transaction_status.status != "refunded" && data.transaction_status.status != "expired") {
                        statusHtml += ' <span class="spinner-border" role="status"></span>';
                    }
                    that._transactionStatusElement.html(statusHtml)
                }
            },
            error: function (data) { },
            complete: function(data) {
                that._unlock();
            }
        });
    }
}

export { ExchangeTransaction }

